import produce from 'immer';

export const PREVIOUS_REFUNDS_PENDING = 'previousRefunds/get/pending';
export const PREVIOUS_REFUNDS_FULFILLED = 'previousRefunds/get/fulfilled';
export const PREVIOUS_REFUNDS_REJECTED = 'previousRefunds/get/rejected';

export const initialState = {
  loading: false,
  error: null,
  data: [],
};

/* eslint-disable default-case, no-param-reassign */
const previousRefunds = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case PREVIOUS_REFUNDS_PENDING:
        draft.loading = true;
        draft.error = false;
        draft.data = [];
        break;
      case PREVIOUS_REFUNDS_FULFILLED:
        draft.loading = false;
        draft.data = action.result;
        break;
      case PREVIOUS_REFUNDS_REJECTED:
        draft.loading = false;
        draft.error = action.error;
        break;
      default:
        break;
    }
  });
export default previousRefunds;
